<template>
  <div>
    <b-card
      style="
        width: 100%;

        margin-left: 0px;
      "
    >
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Facture N</label>

            <input
              class="form-control"
              disabled
              v-model="listes_service[0].id"
            />
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label>Date</label>

            <input
              class="form-control"
              disabled
              v-model="listes_service[0].date"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Matricule</label>

            <input
              class="form-control"
              disabled
              v-model="listes_service[0].service.matr"
            />
          </div>
        </div>
      </div>

      <div class="table-responsive" style="border: 1px solid rgb(235 237 239)">
        <table class="table table-white">
          <thead>
            <tr>
              <!--  <th scope="col">#</th> -->

              <th style="background: #42b883; font-weight: bold; color: #fff">
                <b>QTS</b>
              </th>

              <th style="background: #42b883; font-weight: bold; color: #fff">
                <b>Désignation</b>
              </th>
              <th style="background: #42b883; font-weight: bold; color: #fff">
                <b>P.U</b>
              </th>
              <th style="background: #42b883; font-weight: bold; color: #fff">
                <b>P.T</b>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="border: 2px solid #dddddd"
              v-for="(prog, i) in programmes"
              :key="i"
            >
              <td>
                {{ prog.qts }}
              </td>
              <td>
                {{ prog.titre }}
              </td>
              <td>
                {{ prog.prix.toFixed(3) }}
              </td>
              <td>
                {{ Number(prog.qts) * Number(prog.prix) + ".000" }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <a
          :href="
            'https://apil.auto-turki.com/api/dynamic_pdf/pdfLibre/' +
            this.$route.params.id
          "
          target="_blank"
          style="background-color: transparent !important"
        >
          <div class="md-layout-item md-small-size-10 md-size-10">
            <md-icon style="margin-top: -53px; margin-left: 36px"
              >print</md-icon
            >
          </div>
        </a>
      </div>

      <!--  <div style="padding: 9px; font-size: 33px">
        {{ numeroTolettre2 }} Dinar
      </div> -->

      <!-- ----------- -->

      <!-- -------------- -->
    </b-card>

    <!-- Only include when rendering is required -->

    <!-- Include pdfjs version 2.3.200 for Internet Explorer compatibility, no worker required -->
    <!-- <script src="https://unpkg.com/pdfjs-dist@2.3.200/build/pdf.min.js"></script> -->

    <!-- <div id="app">
  <button @click="createInvoice">Create Invoice</button>
  <button @click="downloadInvoice">Download Invoice</button>
  <button @click="renderInvoice">Render Invoice</button>
  <br />
  <br />
  <p>
    Invoice Base64 (click create invoice):
    <small>{{ invoiceBase64 }}</small>
  </p>
  <div id="pdf"></div>
</div>
  

     
  </div> -->
  </div>
</template>


<script>
import { NumberToLetter } from "convertir-nombre-lettre";
import { apiDomain } from "../../config";
import axios from "axios";

export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  /*  mounted() {
    this.run()
  }, */
  components: {
    NumberToLetter,
  },
  data() {
    return {
      programmes: [],
      de: "de",
      company: {
        name: "My Company",
        address: "38, Bayreuther Straße, 60306, Frankfurt, Hesse, Germany.",
      },
      invoice: {
        id: "",
        items: [],
        /*     {
            description: 'test',
            prix: "40",
            quantity: "0",
              prixx: "40",
          }, 

          {
            description: 'test2',
            prix: "40",
            quantity: "0",
              prixx: "40",
          }, 
         */

        dueDate: "12.2.20",
      },
      customer: {
        name: "Stefan Doe",
        email: "stefandoe@aol.com",
        description: "Steafanie GmbH",
      },
      logo: "",

      listes_service: {},
      selected: [],
      invoiceBase64: "",
    };
  },

  created() {
    this.fetchListesTypes(this.$route.params.id);
  },

  mounted() {
    /*   window.print();
    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
    var fileLink = document.createElement("a");

    fileLink.href = fileURL;
    fileLink.setAttribute("download", "file.pdf");
    document.body.appendChild(fileLink);

    fileLink.click(); */
  },

  computed: {
    somme: function () {
      var sum = 0;
      for (var i = 0; i < this.listes_service[0].Traitement.length; i++) {
        sum +=
          this.listes_service[0].Traitement[i].prix *
          this.listes_service[0].Traitement[i].qts;
      }
      return sum;
    },
    numeroTolettre() {
      var numberToLetters = require("number-2-letters");
      return numberToLetters(this.total);
    },

    numeroTolettre2() {
      const { NumberToLetter } = require("convertir-nombre-lettre");

      // return NumberToLetter();
      return NumberToLetter(this.total);
    },

    total: function () {
      let total = [];

      Object.entries(this.programmes).forEach(([key, val]) => {
        total.push(val.prix * val.qts); // the value of the current key.
      });
      return total.reduce(function (total, num) {
        return total + num;
      }, 0);
    },
  },

  methods: {
    delete_service(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Service  supprimer avec Succès ! ");

          this.fetchListesTypes();
        })

        .catch((err) => console.log(err));
      }
    },
    fetchListesTypes(id) {
      fetch(`${apiDomain}/api/get_factureid/${this.$route.params.id}`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service;
          this.programmes = res.all_service[0].Traitement;
          ///  this.invoice.items =  res.all_service[0].Traitement;
        })
        .catch((err) => console.log(err));
    },
    printDownload() {
      let w = window.open();
      w.document.write(this.$refs.DownloadComp.$el.innerHTML);
      w.document.close();
      w.setTimeout(function () {
        w.print();
      }, 1000);
    },
  },
};
</script>

<style>
.md-table-head-container {
  height: auto;
  padding: 4px;
}
</style>

